<div id="wrapper">
  <app-menu></app-menu>
  <div class="basicrow f-black roboto-r f-reg m-top-ii text-center fix-reset">
    <div class="shortcont">
      <div class="basicrow f-lsemi roboto-r text-center">
        <div class="basicrow">
          <img width="100%" class="mc-icon" src="../../assets/images/reg-c-icon.png">
          Establece tu contraseña
        </div>
      </div>

      <div class="basicrow m-top-i">
        <div>
          Debe modificar la clave de acceso para poder ingresar a su cuenta Claro.
        </div>
        <div class="basicrow m-top-i" style="float: left;">
          <label class="label-f">
            &#42; Nueva Contrase&ntilde;a
          </label>
          <input id="idClaveNueva1" type="password" maxlength="10"
                 placeholder="Escribe una nueva contrase&ntilde;a" class="inp-f" (keyup)="onKey($event)"
                 [(ngModel)]="this.password1" autocomplete="off">
          <app-password-validator></app-password-validator>
        </div>
        <div class="basicrow m-top-i">
          <label class="label-f">
            &#42; Confirmar Nueva Contrase&ntilde;a
          </label>
          <input type="password" placeholder="Confirma la nueva contrase&ntilde;a" class="inp-f"
                 [(ngModel)]="this.password2" autocomplete="off">
        </div>
      </div>
      <div class="basicrow m-top-i">
        <div class="logline full"></div>
      </div>
      <div class="basicrow m-top-i text-center">
        <a class="btns def-iv red centr vcenter">
                  <span class="tabcell" (click)="this.continuePassword()">
                      Continuar &nbsp;&nbsp;<i class="fa fa-angle-right" aria-hidden="true"></i>
                  </span>
        </a>
      </div>
    </div>
  </div>
  <app-footer></app-footer>
</div>

